<template>
  <LoadingLine title="File ảnh đang được cập nhật" :count="taskProgress.progress" />
</template>
<script>
import LoadingLine from '@/components/basic/LoadingLine.vue'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    LoadingLine
  },
  created() {
    if (this.taskProgress.status === 'running') {
      this.interval = setInterval(() => {
        this.fetchTasProgess(this.taskProgress.id)
      }, 3000)
    }
  },
  methods: {
    ...mapActions('taskProgress', ['fetchTasProgess'])
  },
  computed: {
    ...mapGetters('taskProgress', ['taskProgress'])
  },
  beforeDestroy() {
    clearInterval(this.interval)
  }
}
</script>
